import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-circlecheck",
  "use": "icon-circlecheck-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"icon-circlecheck\">\r\n                    <circle cx=\"9.90625\" cy=\"9.9082\" r=\"8.25\" stroke=\"#ADADAD\" stroke-width=\"1.5\" />\r\n                  </symbol>"
});
var result = sprite.add(symbol);
export default symbol